export const AMBIENT_AWARENESS_QUERIES_EXAMPLES = [
  'Notice the color of the sky and describe its shades.',
  'Identify any objects that are red in the scene.',
  'Focus on the patterns or textures in the environment.',
  'Look for any signs of movement and describe them.',
  'Pay attention to the lighting and shadows in the area.',
  'Spot any written text or symbols and read them aloud.',
  'Observe the facial expressions of people around.',
  'Identify any plants or greenery in the surroundings.',
  'Notice the shapes and geometry of nearby objects.',
  'Focus on any reflective surfaces and what they show.',
  'Look for any animals or insects in the vicinity.',
  'Describe the overall mood or atmosphere of the scene.'
];
